import { useState } from 'react';

import {
    Sheet,
    SheetContent,
    SheetDescription,
    SheetHeader,
    SheetTitle,
} from '@nesso/ui/primitives/sheet';

import { AddLocationSheetForm } from './add-location-sheet/add-location-sheet-form';

type Props = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
};

export function AddLocationSheet({ open, onOpenChange }: Props) {
    const [pending, setPending] = useState(false);
    const close = () => onOpenChange(false);

    return (
        <Sheet open={open} onOpenChange={(next) => !pending && onOpenChange(next)}>
            <SheetContent side="right" size="small">
                <SheetHeader>
                    <SheetTitle>New location</SheetTitle>
                    <SheetDescription>
                        Edit your service locations any time from practice setting
                    </SheetDescription>
                </SheetHeader>
                <AddLocationSheetForm
                    onCancel={close}
                    onAdded={close}
                    onPendingChange={setPending}
                />
            </SheetContent>
        </Sheet>
    );
}
